import React, { useEffect, useMemo, useState } from "react";
import { useDispatch } from "react-redux";
import { Box } from "@mui/material";
import { FilterBar, TableData } from "components";
import { getCommercesService } from "services/client/commerceService";
import { getBehaviorReportService } from "services/report/reportService";
import { errorAlert } from "helpers/alerts";
import { currencyFormatter } from "helpers/util";
import { setTitle } from "redux/slices/uiSlice";

const FREQUENCY_OPTIONS = [
  { id: 'day', name: 'Diario' },
  { id: 'week', name: 'Semanal' },
  { id: 'month', name: 'Mensual' },
];

const BehaviorReportScreen = () => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [commerces, setCommerces] = useState([]);
  const [operators, setOperators] = useState([]);
  const [rows, setRows] = useState([]);

  useEffect(() => {
    dispatch(setTitle('Reporte de Comportamiento'));

    getCommercesService(undefined, true)
      .then((result) => {
        setCommerces((result || []).map(({ _id, username }) => ({ id: _id, name: username })));
      })
      .catch((error) => errorAlert(error));
  }, []);

  const handlerSubmit = (data) => {
    const payload = {
      commerce: data.commerce ? [data.commerce] : undefined,
      frequency: data.frequency || 'month',
      operators: data.operators && data.operators.length > 0 ? data.operators : undefined,
    };
    if (!payload.commerce) return
    setLoading(true);
    getBehaviorReportService(payload)
      .then((result) => {
        setRows(result?.rows || []);
        setOperators(result?.operators || []);
      })
      .catch((error) => errorAlert(error))
      .finally(() => setLoading(false));
  };

  const sortedRows = useMemo(
    () => [...rows].sort((a, b) => {
      if ((a.periodStart || 0) === (b.periodStart || 0)) {
        return a.operator.localeCompare(b.operator);
      }
      return (a.periodStart || 0) - (b.periodStart || 0);
    }),
    [rows]
  );

  return (
    <>
      <FilterBar
        handlerFilter={handlerSubmit}
        defaultValues={{
          commerce: '',
          frequency: 'month',
          operators: [],
        }}
        allValue={null}
        filters={[
          {
            name: 'commerce',
            label: "Comercios",
            type: "select",
            data: commerces,
          },
          {
            name: 'frequency',
            label: "Frecuencia",
            type: "select",
            data: FREQUENCY_OPTIONS,
          },
          {
            name: 'operators',
            label: "Operadoras",
            type: "select",
            data: operators,
            multiple: true,
            render: (value) => (value || []).map((id) => operators.find((item) => item.id === id)?.name).filter(Boolean).join(', '),
          },
        ]}
      />
      <Box mt={2}>
        <TableData
          loading={loading}
          dataRows={sortedRows}
          dataTitle={[
            'Fecha',
            'Operadora',
            'No. Txn',
            'Monto total',
          ]}
          formatter={(data) => ([
            data.period,
            data.operator,
            data.txns,
            currencyFormatter.format(data.totalAmount || 0),
          ])}
          search={false}
        />
      </Box>
    </>
  );
};

export default BehaviorReportScreen;
